import { Organization } from "./organization.model";

export class Theme {
  constructor(
    public id: string = "",
    public subdomain: string = "",
    public organization: Organization
  ) {}
}

export class ThemePayload {
  constructor(
    public subdomain: string = "",
    public partners?: any,
    public logo?: any,
    public theme?: ITheme,
    public organizationId?: string
  ) {}
}

export interface IColorShades {
  50: string;
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
  700: string;
  800: string;
  900: string;
}

export interface IThemeColors {
  "h-primary": IColorShades | string;
  "h-secondary": IColorShades | string;
}

export interface ITheme {
  colors: IThemeColors;
}
